import { useEffect, useState } from 'react';
import { fetchPrcWallet } from '../api/transactions';

export function usePrcWallet(address, page = 1) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const normalized = String(address || '').trim();
    if (!normalized) {
      setLoading(false);
      setError('Invalid PRC wallet address.');
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);
    setData(null);

    fetchPrcWallet(normalized, page)
      .then((result) => {
        if (!cancelled) {
          setData(result);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.response?.data?.message || err.message || 'Wallet not found.');
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [address, page]);

  return { data, loading, error, display: data?.display };
}
